import { cloneDeep, reverse } from 'lodash';
import { traverseTrees } from '@meitu/saas-editor-core/es/utils/tree-kit';
import { ILayerProps, LayerType } from '@meitu/saas-editor-core/es/version-types';
import { imgModeOptions } from '@/editor/panel/views/image-panel/type';

export const reverseLayers = (layers: ILayerProps[]) => {
    const newLayers = reverse(cloneDeep(layers).filter((item) => item.layerType !== LayerType.BACKGROUND_LAYER));

    traverseTrees(newLayers, (child: ILayerProps) => {
        if (child.layerType === LayerType.GROUP_LAYER) {
            child.children = reverse(child.children);
        }
    });
    return newLayers;
};

export const getAllParentLayerByLayerId = (
    layers: ILayerProps[],
    layerId: string,
    parentLayers: ILayerProps[] = [],
) => {
    let childLayer: ILayerProps | null = null;
    let parentLayer: ILayerProps | null = null;
    traverseTrees(layers, (child: ILayerProps) => {
        if (child.id === layerId) {
            childLayer = child;
        }
    });

    if (childLayer && (childLayer as ILayerProps).parentId) {
        traverseTrees(layers, (child: ILayerProps) => {
            if (child.id === (childLayer as ILayerProps).parentId) {
                parentLayer = child;
                parentLayers.push(child);
            }
        });

        if (parentLayer) {
            getAllParentLayerByLayerId(layers, (parentLayer as ILayerProps).id, parentLayers);
        }
    }
};

export const imgModeMap = imgModeOptions.reduce(
    (acc: any, cur: any) => {
        acc[cur.value] = `${cur.label}`;
        return acc;
    },
    {} as Record<string, string>,
);
